<template>
  <div class="row">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  computed: {},
  created () {}
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/Commands/Commands.vue